import { Link } from 'react-router-dom';
import { getBookImage, handleBookImageError } from '../../utils';
import { useCurrency } from '../../context/CurrencyContext';
import StockOverlay from '../common/StockOverlay';

// Amazon-style "Keep shopping for / Continue shopping for / Explore more"
// 4-card showcase. Each card shows a 2x2 grid of small product thumbnails
// with prices and a "See more" link at the bottom.
const MiscShowcase = ({ cards }) => {
  const { formatBookPrice } = useCurrency();

  if (!cards || cards.length === 0) return null;

  return (
    <section
      className="w-full mx-auto px-4 py-3"
      aria-label="Recommended for you"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((card) => (
          <article
            key={card.title}
            className="bg-white border border-gray-200 rounded-md p-4 flex flex-col min-w-0 w-full max-w-full overflow-hidden"
          >
            <h2 className="text-base sm:text-lg font-bold text-black mb-3 line-clamp-2">
              {card.title}
            </h2>

            <div className="grid grid-cols-[repeat(2,minmax(0,1fr))] gap-2 flex-1 w-full min-w-0">
              {card.items.slice(0, 4).map((item) => (
                <Link
                  key={item.id}
                  to={`/book/${item.id}`}
                  className="block group min-w-0 max-w-full overflow-hidden"
                >
                  <div className="relative aspect-square w-full min-w-0 bg-gray-50 rounded overflow-hidden">
                    <img
                      src={getBookImage(item.image)}
                      onError={handleBookImageError}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                      referrerPolicy="no-referrer"
                    />
                    <StockOverlay stock={item.stock} compact />
                  </div>
                  <p className="text-xs sm:text-sm text-black line-clamp-1 mt-1 group-hover:text-orange-600">
                    {item.title}
                  </p>
                  {item.price != null && (
                    <p className="text-sm font-semibold text-black mt-0.5">
                      {formatBookPrice(item)}
                    </p>
                  )}
                </Link>
              ))}
            </div>

            <Link
              to={card.link || '/shop'}
              className="mt-4 text-sm text-blue-700 hover:text-orange-600 hover:underline"
            >
              See more
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
};

export default MiscShowcase;
